export const dashboardMeta = {
  name: 'clinical-views',
  slot: 'patient-chart-clinical-view-dashboard-slot',
  config: { columns: 1, type: 'grid' },
  title: 'Clinical Views',
};
